import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableMaterial = QueryHookResult<
  typeof useMaterialsQuery
>[number];

export const useMaterialsQuery = createQueryHook(
  'shared.selectMaterial',
  (params: {
    ids?: string[];
    searchTerm?: string;
    limit?: number;
    offset?: number;
  }) => ({
    items: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: params.limit ?? 20,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        skuNumber: true,
        effectivePricingUnit: true,
        colorHue: true,
        itemGroup: {
          id: true,
          name: true,
          colorHue: true,
        },
        category: {
          id: true,
          name: true,
          attributes: true,
        },
        attributeValues: true,
      },
    },
  }),
  {
    select: (data) => data?.items.entries ?? [],
  },
);

type EntityProps = {
  id: string;
  name: string;
  skuNumber: string;
  itemGroup?: {
    id?: string;
    name?: string;
  } | null;
};

const formatOptionLabelText = (entity: EntityProps) => {
  const sku = entity.skuNumber?.replace(/_/g, ' ') ?? '';
  const relevantSkuNumber = sku.length > 20 ? undefined : sku;
  const numericPart = relevantSkuNumber?.match(/\d+/)?.[0];

  return `${numericPart ? `#${numericPart} - ` : ''}${entity.name}`;
};

export const SelectMaterialTouch = createEntityTouchSelect.remotelySearched(
  'SelectMaterial',
  useMaterialsQuery,
  {
    formatLabel: (entity) => `${formatOptionLabelText(entity)}`,
    formatSubLabel: (entity) => entity.itemGroup?.name ?? '',
  },
);
